export default {
  name: 'live-pulse-indicator',
  props: {
    /**
     * Pulse colour variant: primary | success | warning | error | off
     */
    status: {
      type: String,
      default: 'primary',
      validator (value) {
        return ['primary', 'success', 'warning', 'error', 'off'].indexOf(value) !== -1
      }
    },
    size: {
      type: Number,
      default: 24
    },
    icon: {
      type: String,
      default: 'fal fa-location-circle'
    },
    errorIcon: {
      type: String,
      default: 'fas fa-exclamation-triangle'
    },
    showErrorIcon: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  computed: {
    pulseClass () {
      const classes = ['pulse-generator']
      if (this.status && this.status !== 'primary') {
        classes.push(`pulse-generator--${this.status}`)
      }
      return classes
    },
    sizeStyle () {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`
      }
    }
  }
}
